// extracted by mini-css-extract-plugin
export default {"empty":"ProjectCandidatesListEmpty_empty__45Y7J"};